



















import { Vue, Component } from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {Config} from "vuescroll";

import {ops} from "@/constants/vueScrollConfig";

import {IActiveShipment} from "@/models/StoreModels";

import ActiveShipmentCard from '@/views/components/Home/dropup/components/ActiveShipmentList/ActiveShipmentCard/ActiveShipmentCard.vue';
import {ShipmentLogic} from "@/models/ShipmentLogic";

const activeShipmentsModule = namespace('activeShipments');
const userData = namespace("userData");

@Component({
  name: 'ActiveShipmentsList',
  components: {
    ActiveShipmentCard,
  },
})
export default class ActiveShipmentsList extends Vue {
  private readonly ops: Config = ops;

  @activeShipmentsModule.Getter('getActiveOrderList')
  private getActiveShipmentList!: IActiveShipment[];

  @userData.Getter('getId')
  private userId!: number;

  private get existsActiveShipments(): boolean {
    return this.getActiveShipmentList.length > 0;
  }

  private get activeShipmentListOrdered(): IActiveShipment[] {
    const waitingUserActionList: IActiveShipment[] = [];
    const passiveList: IActiveShipment[] = [];

    this.getActiveShipmentList.map((shipment: IActiveShipment) => {
      ShipmentLogic.userCanInteractWith(shipment, this.userId) ?
        waitingUserActionList.unshift(shipment) :
        passiveList.unshift(shipment);
    });

    return [...waitingUserActionList, ...passiveList];
  }

}
